<template>
    <BaseNotification v-if="notification" :text="notification.message" theme="error" hide-dismiss />
</template>

<script setup lang="ts">
import { useFetch } from "~vue/api";
import BaseNotification from "~vue/components/BaseNotification.vue";
import { computed } from "vue";

interface GlobalNotification {
    name: string;
    message: string;
}

const { data: notifications } = useFetch("/admin/global-notifications/").get().json<GlobalNotification[]>();
const notification = computed(() => notifications.value?.[0]);
</script>
